import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { ToastService } from 'libs/mdbootstrap/typescripts/pro';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import * as Models from 'app/core/models';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';
import { ModalService } from 'app/modal/modal.service';
import { ProcessService } from 'app/core/process/process.service';

@Component({
  selector: 'app-contact-creator-modal',
  templateUrl: './contactCreatorModal.component.html',
  styleUrls: ['./contactCreatorModal.component.scss']
})
export class ContactCreatorModalComponent implements OnInit, Models.ModalComponent {

  @ViewChild('modalContactCreator') public contentModal: any;

  error: any = null;
  isSending = false;
  message: string;
  processExecutionId: string;
  satgeOrder: number;
  stageTitle: string;
  stepOrder: number;
  stepTitle: string;
  isLoading: boolean;

  constructor(private authenticationService: AuthenticationService,
              private userService: UserService,
              private router: Router,
              private lookupService: LookupService,
              private modalService: ModalService,
              private processService: ProcessService,
              private toastrService: ToastService) {
  }

  ngOnInit() {
    this.error = null;
    this.isSending = false;
    this.message = '';
  }

  open() {
    this.contentModal.show();
  }

  close() {
    this.contentModal.hide();
  }

  cancel(): void {
    const data: Models.ModalContext = {
      modalType: Models.ModalType.CONTACT_CREATOR,
      modalAction: Models.ModalAction.CLOSE,
      parameters: []
    };
    this.modalService.command(data);
  }

  closeModal() {
    this.close();
  }

  openModal(data: any[]): void {
    this.processExecutionId = data[0];
    this.satgeOrder = data[1];
    this.stageTitle = data[2];
    this.stepOrder = data[3];
    this.stepTitle = data[4];
    this.error = null;
    this.isSending = false;
    this.message = '';

    this.open();
  }

  send(): void {
    this.isSending = true;
    this.sendMessage();
  }

  sendMessage(): void {
    const conatctData: Models.ContactProcessCreatorModel = {
      processExecutionId: this.processExecutionId,
      message: this.message,
      stageOrder: this.satgeOrder,
      stageTitle: this.stageTitle,
      stepOrder: this.stepOrder,
      stepTitle: this.stepTitle
    };

    this.processService.contactProcessCreator(conatctData)
    // @TODO@ translate
      .finally(() => {
        this.isSending = false;
      })
      .subscribe(result => {
          this.toastrService.success('Your message was sent sucessfully!');
          this.cancel();
        }
        , error => {
          this.error = error;
          const options = { enableHtml: true };
          this.toastrService.error(this.errorMessage + '<br /> Please try again.', 'There was an error:', options);
        });
  }

  get errorMessage(): string {
    // @TODO@ translate
    if (this.error) {
      const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
      if (errorBody && errorBody.error) {
        return errorBody.error;
      }
    }
    return 'There was a problem.';
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/contactCreatorModal/contactCreatorModal.component.ts